import React from 'react';
import { useQuery } from '@common/hooks';
import { Drawer, ErrorHandler } from '@common/components';
import { WorkforceGroupUnitRatesLogQuery } from '@scheduling/graphql';
import { now, toISODateFormat } from 'works/legacy/lib/date-helper';
import { IncentiveRatesViewDrawerRatesLog } from './_incentive-rates-view-drawer-rates-log';

export function IncentiveRatesViewDrawer({
  open,
  onClose,
  workforceGroupId = '',
  organizationUnitId = '',
}: {
  open: boolean;
  onClose: () => void;
  workforceGroupId?: string;
  organizationUnitId?: string;
}) {
  const { data, error, loading } = useQuery(WorkforceGroupUnitRatesLogQuery, {
    skip: !workforceGroupId || !organizationUnitId,
    variables: {
      effectiveDate: toISODateFormat(now()),
      workforceGroupId,
      organizationUnitId,
    },
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="IncentiveRatesViewDrawer"
        messageType="contextual"
      />
    );
  }

  return (
    <Drawer
      size="lg"
      open={open}
      onClose={onClose}
      title="View Rates"
      className="rates-on-demand-view-drawer"
      loading={loading || !data}
    >
      {data && (
        <IncentiveRatesViewDrawerRatesLog
          data={data.workforceGroupUnitRatesLog}
        />
      )}
    </Drawer>
  );
}
